module.exports = __webpack_public_path__ + "images/item-menu-d51efdd7.svg";